<div *ngIf="userType === 'parent'" class="navbar-container">
    <button class="button" (click)="goToParentHomePage()">
        <img src="assets/images/footer/Icon-3-Deselected.png" alt="Dashboard Icon">
    </button>

    <button class="button" (click)="goToGabadooPage()">
      <img src="assets/images/footer/Icon.png"  alt="Gabadoos Icon">
    </button>

    <button class="button" (click)="goToGabadooFaq()">
<!--      <img src="assets/images/footer/faq_icon.png" style="height: 25px"  alt="QA Icon">-->
      <mat-icon style="color: grey">question_mark</mat-icon>
    </button>

    <button class="button" (click)="goToParentAccount()">
      <img src="assets/images/footer/Icon-2.png"  alt="Profile Icon">
    </button>
</div>


<div *ngIf="userType === 'partner'" class="navbar-container-partner">

  <button mat-mini-fab class="partner-home-btn"  (click)="goToPartnerHomePage()">
    <img src="assets/images/footer/Icon-3-Deselected.png" alt="Home Icon" class="center-icon" title="Home">
    <span class="partner-btn-text">Home</span>
  </button>

  <button  mat-mini-fab class="gabadoo-btn" (click)="goToGabadooPageForPartner()">
    <img src="assets/images/footer/Icon.png" class="center-icon"  alt="Gabadoos Icon" title="Gabadoo">
    <span class="partner-btn-text" style="left: -15px">Gaba Plans</span>
  </button>


  <button  mat-mini-fab class="account-btn"  (click)="goToPartnerAccount()">
    <img src="assets/images/footer/Icon-2.png" class="center-icon"  alt="Profile Icon" title="Account">
    <span class="partner-btn-text">Account</span>
  </button>
</div>

